import React from 'react';
import '../constants/AssetsCss';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GetORPostAsync, { copyToClipboard } from '../constants/restservice';
import swal from 'sweetalert';
import withRouter from '../constants/withRouter';


class Deposit extends React.Component {
    constructor(props) {
        super(props);
        this.onAmountChanged = this.onAmountChanged.bind(this);
        this.getDepositDetails = this.getDepositDetails.bind(this);
        this.onMethodChanged = this.onMethodChanged.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.state = {
            country: "",
            amount: "",
            method: "BTC",
            showForm: { display: "block" },
            showQR: { display: "none" },
            qrText: "",
            amountForDep: "",
            depositmessage: ""
        }
    }
    componentDidMount() {
        this.getProfileDetails();
        this.getDepositHistory();
    }
    onMethodChanged(event) {
        this.setState({ method: event.target.value });
    }
    onAmountChanged(event) {
        this.setState({ amount: event.target.value });
    }
    async getProfileDetails() {
        let res = await GetORPostAsync("MyProfile.asp", "GET", null, localStorage.getItem("token"));
        if (res.status === "error") {
            toast(res.message);
            if (res.message === "Session Expired") {
                this.props.history.push({
                    pathname: "/"
                });
            }
            return;
        }
        this.setState({ country: res.country });
    }
    async onComplete() {
        this.setState({
            showForm: { display: "block" },
            showQR: { display: "none" }
        });
        this.getDepositHistory();
    }
    async getDepositDetails() {
        if (!this.state.amount) {
            toast("Enter a Amount");
            return;
        }
        if (this.state.method === "TRX") {
            swal({
                title: "Under maintenance",
                text: "Will be back soon.",
                icon: "info"
            });
            return;
        }
        let json = {
            usd: this.state.amount,
            method: this.state.method
        }
        let res = await GetORPostAsync("deposit.asp", "POST", JSON.stringify(json), localStorage.getItem("token"));
        if (res.status.toLowerCase() === "error") {
            toast(res.message);
            if (res.message === "Session Expired") {
                this.props.history.push({
                    pathname: "/"
                });
            }
            return;
        }
        this.setState({ depositmessage: "Please Deposit Your " + this.state.method, qrText: res.WalletAddress, amountForDep: res.btcinUSD, showForm: { display: "none" }, showQR: { display: "block" } });

    }
    async getDepositHistory() {
        let res = await GetORPostAsync("deposithistory.asp", "GET", null, localStorage.getItem("token"));
        if (res.status === "error") {
            this.setState({ depositHistoryTable: "<tr><td colSpan='5'>No Records</td></tr>" });
            return;
        }
        let str = "";
        for (let i = 0; i < res.items.length; i++) {
            str += '<tr><td class="bg-color-1 text-white">' + (i + 1) + '</td><td>' + res.items[i].Date + '</td><td>' + res.items[i].Requested + '</td><td>' + res.items[i].address + '</td><td>' + res.items[i].Status + '</td></tr>';
            if (i === res.items.length - 1) {
                this.setState({ depositHistoryTable: str });
            }
        }
    }
    render() {
        return (<div><div className="page-header">
            <div className="page-leftheader">
                <h4 className="page-title mb-0">Hi! {localStorage.getItem('fullname')}</h4>
                {/* <ol className="breadcrumb">
                    <li className="breadcrumb-item"><label><i className="fe fe-home mr-2 fs-14"></i>Main</label></li>
                    <li className="breadcrumb-item active" aria-current="page"><label>Deposit</label></li>
                </ol> */}
            </div>
        </div>
            <div className="row" style={this.state.showForm}>
                <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
                    <div className="card overflow-hidden dash1-card border-0 ">
                        <div className="card-body">
                            <h5 className=" mt-3 mb-3">Deposit </h5>
                            <hr />
                            <div class="form-body mt-4"><div class="row">
                                <div class="col-lg-8"><div class="border border-3 p-4 rounded">
                                    <div class="mb-3">
                                        <label for="inputProductTitle" class="form-label">Amount to deposit</label>
                                        <input type="email" class="form-control" placeholder="Deposit amount" onChange={this.onAmountChanged} value={this.state.amount} />
                                    </div>
                                    <div class="mb-3 mt-5">
                                        <div class="d-grid">
                                            <button type="submit" onClick={this.getDepositDetails} class="btn btn-primary w-100">Deposit</button>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div className="row" style={this.state.showQR}>
                <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
                    <div className="card overflow-hidden dash1-card border-0 ">
                        <div className="card-body text-center">
                            <h2 className=" mt-5 mb-5">Please Deposit Your DNET</h2>
                            <h5 className=" mt-5 mb-5">Deposit Amount : {this.state.amount} DNET (BEP20)</h5>
                            <img
                                style={{ border: "1px solid", borderRadius: 5,maxWidth:200,marginBottom:10 }}
                                src={`https://qrcode.tec-it.com/API/QRCode?data=${this.state.qrText}`}
                                alt=''
                            />
                            <br />
                            <h6 className="mt-2 mb-2">{this.state.qrText}</h6>
                            {/* <QRCode className="mt-5 mb-5" value={this.state.qrText} /><br /> */}
                            <button className="mt-5 mb-5 btn btn-color-1" onClick={(e) => {
                                copyToClipboard(this.state.qrText);
                            }}>Copy</button>
                            <button className="mt-5 mb-5 ml-2 btn btn-color-1" onClick={this.onComplete}>Completed</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title text-color-3" style={{ fontWeight: "200", fontSize: "22px" }}>Deposit History</h3>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table style={{ textAlign: "center" }} className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top">
                                    <thead className="">
                                        <tr>
                                            <th>S.No</th>
                                            <th>Date</th>
                                            <th>Amount</th>
                                            <th>Received Address</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody dangerouslySetInnerHTML={{ __html: this.state.depositHistoryTable }}>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

export default  withRouter(Deposit);